import { createReducer } from '../../helpers/reducer';

const initState = {
  logs: null,
  loading: false,
  total: 0,
  filteredTotal: 0,
  filters: null,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { logs, total, filteredTotal, filters } = payload;

  return {
    ...state,
    logs,
    total,
    filteredTotal,
    filters,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

const getReducerByDocument = actions => {
  return createReducer(initState, {
    [actions.LOAD]: onLoad,
    [actions.LOAD_SUCCESS]: onLoadSuccess,
    [actions.CLEAR_STORE]: onClearStore,
  });
};

export default getReducerByDocument;
